export const CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO = 'CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO';
export const CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS = 'CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS';

export const CALENDARIO_FERIADO_LOAD_PUBLICO = 'CALENDARIO_FERIADO_LOAD_PUBLICO';
export const CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS = 'CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS';
export const CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL = 'CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL';

export const CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR = 'CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR';
export const CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_SUCCESS = 'CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_SUCCESS';
export const CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_FAIL = 'CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_FAIL';

export const CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS = 'CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS';
export const CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_SUCCESS = 'CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_SUCCESS';
export const CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_FAIL = 'CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_FAIL';

export const CALENDARIO_FERIADO_CRIAR = 'CALENDARIO_FERIADO_CRIAR';
export const CALENDARIO_FERIADO_CRIAR_SUCCESS = 'CALENDARIO_FERIADO_CRIAR_SUCCESS';

export const CALENDARIO_FERIADO_ATUALIZAR = 'CALENDARIO_FERIADO_ATUALIZAR';
export const CALENDARIO_FERIADO_ATUALIZAR_SUCCESS = 'CALENDARIO_FERIADO_ATUALIZAR_SUCCESS';

export const CALENDARIO_FERIADO_INVALIDAR = 'CALENDARIO_FERIADO_INVALIDAR';
export const CALENDARIO_FERIADO_INVALIDAR_SUCCESS = 'CALENDARIO_FERIADO_INVALIDAR_SUCCESS';

export const CALENDARIO_FERIADO_REVALIDAR = 'CALENDARIO_FERIADO_REVALIDAR';
export const CALENDARIO_FERIADO_REVALIDAR_SUCCESS = 'CALENDARIO_FERIADO_REVALIDAR_SUCCESS';

export const CALENDARIO_FERIADO_CLEAN = 'CALENDARIO_FERIADO_CLEAN';
